import PropTypes from 'prop-types';

function ProgramInfoItem({ title, options = [] }) {
  return (
    <li key={title}>
      <strong>
        {`${title}: `}
      </strong>
      {options}
    </li>
  );
}

ProgramInfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

export default ProgramInfoItem;
